import './auth.css'
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { login, signup, getCountUsers } from './authActions'
import Row from '../common/layout/row'
import Grid from '../common/layout/grid'
import Messages from '../common/msg/messages'
import Input from '../common/form/inputAuth'
import If from '../common/operador/if'

class Auth extends Component {
    constructor(props) {
        super(props)
        this.state = { loginMode: true }

    }

    componentWillMount() {
        this.props.getCountUsers()
    }

    changeMode() {
        this.setState({ loginMode: !this.state.loginMode })
    }

    onSubmit(values) {
        const { login, signup } = this.props
        this.state.loginMode ? login(values) : signup(values)
    }

    render() {
        const { loginMode } = this.state
        const { handleSubmit } = this.props
        return (
            <div>
                <div className="login-box">
                    <div className="login-logo">Gestor de Boletos <i className="fa fa-barcode"></i></div>
                    <div className="login-box-body">
                        <div className='div_logo_empresa' > <img className='logo_empresa' src="/logosdr.png" alt="bg image" fluid /> </div>

                        <form onSubmit={handleSubmit(v => this.onSubmit(v))}>
                            <Field component={Input} type="input" name="name"
                                placeholder="Nome" icon='user' hide={loginMode} />
                            <Field component={Input} type="email" name="email"
                                placeholder="E-mail" icon='envelope' />
                            <Field component={Input} type="password" name="password"
                                placeholder="Senha" icon='lock' />
                            <Field component={Input} type="password" name="confirm_password"
                                placeholder="Confirmar Senha" icon='lock' hide={loginMode} />
                            <Row>
                                <Grid cols="4">
                                    <button type="submit"
                                        className="btn btn-primary btn-block btn-flat">
                                        {loginMode ? 'Entrar' : 'Registrar'}
                                    </button>
                                </Grid>
                            </Row>
                        </form>
                        <br />
                        <If test={this.props.qtd_user === 0}>
                            <a onClick={() => this.changeMode()}  >
                                {loginMode ? 'Novo usuário? Registrar aqui!' :
                                    'Já é cadastrado? Entrar aqui!'}
                            </a>
                        </If>
                    </div>
                    <Messages />
                </div>
               
            </div>

        )
    }
}

Auth = reduxForm({ form: 'authForm' })(Auth)
const mapStateToProps = state => ({ qtd_user: state.auth.qtd_user })
const mapDispatchToProps = dispatch => bindActionCreators({ login, signup, getCountUsers }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Auth)


// WEBPACK FOOTER //
// ./src/auth/auth.jsx